import { PayloadAction } from '@reduxjs/toolkit';

import { OverlayState } from './reducer';

export const toggleOverlay = (state: OverlayState, action: PayloadAction<boolean>) => {
  state.value = action.payload
};
